<template>
  <el-select
    v-model="selfCheckValues" :multiple="false" filterable
    remote reserve-keyword
    v-bind:placeholder="this.selfOptions._placeholder"
    v-on:change="onChange"
    clearable
    :remote-method="remoteMethod"
    :loading="loading">
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
  import { actionClient } from '@/api';
  export default {
    /**
     * options 参数
     * path string 后台获取数据路径
     * default string 默认选中数据
     * _placeholder 默认显示内容
     */
    props: {
      specValues : {type: String, required:true},
      action : {type : String, required : true},
      labelField : {type : String, required : false},
      valueField : {type : String, required : false},
      keywordField : {type : String, required : false},
      _placeholder : {type : String, required : false},
    },
    model: {
      prop: "specValues", //绑定的值，通过父组件传递
      event: "specPickerUpdate" //自定义事件名
    },
    data() {
      return {
        selfCheckValues: '',
        list: [],
        loading: false,
        states: [],
        selfOptions:{
          action: '',
          labelField: 'lable',
          valueField: 'value',
          keywordField: 'name',
          _placeholder: '请输入',
        },
      }
    },
    methods: {
      remoteMethod(query) {
        this.getSpecs(query).then(this.specsMap);
      },
      specsMap() {
        this.list = this.states.map(item => {
          return { value: item[this.selfOptions.valueField], label: item[this.selfOptions.labelField] };
        });
      },
      async getSpecs(name) {
        const query = {name};
        this.states = await actionClient.get(this.selfOptions.action, {query});
      },
      onChange(value) {
        this.$emit("specPickerUpdate", value); //子组件与父组件通讯，告知父组件更新绑定的值
      },
    },
    mounted() {
      this.selfOptions = {
        action: this.action,
        labelField : this.labelField ? this.labelField : this.selfOptions.labelField,
        valueField : this.valueField ? this.valueField : this.selfOptions.valueField,
        keywordField : this.keywordField ? this.keywordField : this.selfOptions.keywordField,
        _placeholder : this._placeholder ? this._placeholder : this.selfOptions._placeholder,
      };

      // console.log(this.selfOptions);
      if(this.selfOptions.defaultValue) {
        this.selfCheckValues = this.selfOptions.defaultValue;
        this.remoteMethod(this.selfOptions.defaultValue);
      }
    }
  }
</script>
